// Complete E.164 country calling codes
// label = code only, name = country/region

export const PHONE_COUNTRY_CODES = [
  { value: '+1', label: '+1', name: 'USA / Canada' },

  { value: '+7', label: '+7', name: 'Russia / Kazakhstan' },

  { value: '+20', label: '+20', name: 'Egypt' },
  { value: '+27', label: '+27', name: 'South Africa' },
  { value: '+30', label: '+30', name: 'Greece' },
  { value: '+31', label: '+31', name: 'Netherlands' },
  { value: '+32', label: '+32', name: 'Belgium' },
  { value: '+33', label: '+33', name: 'France' },
  { value: '+34', label: '+34', name: 'Spain' },
  { value: '+36', label: '+36', name: 'Hungary' },
  { value: '+39', label: '+39', name: 'Italy' },
  { value: '+40', label: '+40', name: 'Romania' },
  { value: '+41', label: '+41', name: 'Switzerland' },
  { value: '+43', label: '+43', name: 'Austria' },
  { value: '+44', label: '+44', name: 'United Kingdom' },
  { value: '+45', label: '+45', name: 'Denmark' },
  { value: '+46', label: '+46', name: 'Sweden' },
  { value: '+47', label: '+47', name: 'Norway' },
  { value: '+48', label: '+48', name: 'Poland' },
  { value: '+49', label: '+49', name: 'Germany' },

  { value: '+51', label: '+51', name: 'Peru' },
  { value: '+52', label: '+52', name: 'Mexico' },
  { value: '+53', label: '+53', name: 'Cuba' },
  { value: '+54', label: '+54', name: 'Argentina' },
  { value: '+55', label: '+55', name: 'Brazil' },
  { value: '+56', label: '+56', name: 'Chile' },
  { value: '+57', label: '+57', name: 'Colombia' },
  { value: '+58', label: '+58', name: 'Venezuela' },

  { value: '+60', label: '+60', name: 'Malaysia' },
  { value: '+61', label: '+61', name: 'Australia' },
  { value: '+62', label: '+62', name: 'Indonesia' },
  { value: '+63', label: '+63', name: 'Philippines' },
  { value: '+64', label: '+64', name: 'New Zealand' },
  { value: '+65', label: '+65', name: 'Singapore' },
  { value: '+66', label: '+66', name: 'Thailand' },

  { value: '+81', label: '+81', name: 'Japan' },
  { value: '+82', label: '+82', name: 'South Korea' },
  { value: '+84', label: '+84', name: 'Vietnam' },
  { value: '+86', label: '+86', name: 'China' },

  { value: '+90', label: '+90', name: 'Turkey' },
  { value: '+91', label: '+91', name: 'India' },
  { value: '+92', label: '+92', name: 'Pakistan' },
  { value: '+93', label: '+93', name: 'Afghanistan' },
  { value: '+94', label: '+94', name: 'Sri Lanka' },
  { value: '+95', label: '+95', name: 'Myanmar' },
  { value: '+98', label: '+98', name: 'Iran' },

  { value: '+212', label: '+212', name: 'Morocco' },
  { value: '+213', label: '+213', name: 'Algeria' },
  { value: '+216', label: '+216', name: 'Tunisia' },
  { value: '+218', label: '+218', name: 'Libya' },
  { value: '+220', label: '+220', name: 'Gambia' },
  { value: '+221', label: '+221', name: 'Senegal' },
  { value: '+222', label: '+222', name: 'Mauritania' },
  { value: '+223', label: '+223', name: 'Mali' },
  { value: '+224', label: '+224', name: 'Guinea' },
  { value: '+225', label: '+225', name: 'Ivory Coast' },
  { value: '+226', label: '+226', name: 'Burkina Faso' },
  { value: '+227', label: '+227', name: 'Niger' },
  { value: '+228', label: '+228', name: 'Togo' },
  { value: '+229', label: '+229', name: 'Benin' },
  { value: '+230', label: '+230', name: 'Mauritius' },
  { value: '+231', label: '+231', name: 'Liberia' },
  { value: '+232', label: '+232', name: 'Sierra Leone' },
  { value: '+233', label: '+233', name: 'Ghana' },
  { value: '+234', label: '+234', name: 'Nigeria' },
  { value: '+235', label: '+235', name: 'Chad' },
  { value: '+236', label: '+236', name: 'Central African Republic' },
  { value: '+237', label: '+237', name: 'Cameroon' },
  { value: '+238', label: '+238', name: 'Cape Verde' },
  { value: '+239', label: '+239', name: 'São Tomé & Príncipe' },
  { value: '+240', label: '+240', name: 'Equatorial Guinea' },
  { value: '+241', label: '+241', name: 'Gabon' },
  { value: '+242', label: '+242', name: 'Congo' },
  { value: '+243', label: '+243', name: 'DR Congo' },
  { value: '+244', label: '+244', name: 'Angola' },
  { value: '+245', label: '+245', name: 'Guinea-Bissau' },
  { value: '+246', label: '+246', name: 'Diego Garcia' },
  { value: '+248', label: '+248', name: 'Seychelles' },
  { value: '+249', label: '+249', name: 'Sudan' },
  { value: '+250', label: '+250', name: 'Rwanda' },
  { value: '+251', label: '+251', name: 'Ethiopia' },
  { value: '+252', label: '+252', name: 'Somalia' },
  { value: '+253', label: '+253', name: 'Djibouti' },
  { value: '+254', label: '+254', name: 'Kenya' },
  { value: '+255', label: '+255', name: 'Tanzania' },
  { value: '+256', label: '+256', name: 'Uganda' },
  { value: '+257', label: '+257', name: 'Burundi' },
  { value: '+258', label: '+258', name: 'Mozambique' },
  { value: '+260', label: '+260', name: 'Zambia' },
  { value: '+261', label: '+261', name: 'Madagascar' },
  { value: '+262', label: '+262', name: 'Réunion' },
  { value: '+263', label: '+263', name: 'Zimbabwe' },
  { value: '+264', label: '+264', name: 'Namibia' },
  { value: '+265', label: '+265', name: 'Malawi' },
  { value: '+266', label: '+266', name: 'Lesotho' },
  { value: '+267', label: '+267', name: 'Botswana' },
  { value: '+268', label: '+268', name: 'Eswatini' },
  { value: '+269', label: '+269', name: 'Comoros' },

  { value: '+350', label: '+350', name: 'Gibraltar' },
  { value: '+351', label: '+351', name: 'Portugal' },
  { value: '+352', label: '+352', name: 'Luxembourg' },
  { value: '+353', label: '+353', name: 'Ireland' },
  { value: '+354', label: '+354', name: 'Iceland' },
  { value: '+355', label: '+355', name: 'Albania' },
  { value: '+356', label: '+356', name: 'Malta' },
  { value: '+357', label: '+357', name: 'Cyprus' },
  { value: '+358', label: '+358', name: 'Finland' },
  { value: '+359', label: '+359', name: 'Bulgaria' },

  { value: '+370', label: '+370', name: 'Lithuania' },
  { value: '+371', label: '+371', name: 'Latvia' },
  { value: '+372', label: '+372', name: 'Estonia' },
  { value: '+373', label: '+373', name: 'Moldova' },
  { value: '+374', label: '+374', name: 'Armenia' },
  { value: '+375', label: '+375', name: 'Belarus' },
  { value: '+376', label: '+376', name: 'Andorra' },
  { value: '+377', label: '+377', name: 'Monaco' },
  { value: '+378', label: '+378', name: 'San Marino' },
  { value: '+380', label: '+380', name: 'Ukraine' },
  { value: '+381', label: '+381', name: 'Serbia' },
  { value: '+382', label: '+382', name: 'Montenegro' },
  { value: '+383', label: '+383', name: 'Kosovo' },
  { value: '+385', label: '+385', name: 'Croatia' },
  { value: '+386', label: '+386', name: 'Slovenia' },
  { value: '+387', label: '+387', name: 'Bosnia & Herzegovina' },
  { value: '+389', label: '+389', name: 'North Macedonia' },

  { value: '+420', label: '+420', name: 'Czech Republic' },
  { value: '+421', label: '+421', name: 'Slovakia' },

  { value: '+852', label: '+852', name: 'Hong Kong' },
  { value: '+853', label: '+853', name: 'Macau' },
  { value: '+855', label: '+855', name: 'Cambodia' },
  { value: '+856', label: '+856', name: 'Laos' },

  { value: '+880', label: '+880', name: 'Bangladesh' },
  { value: '+886', label: '+886', name: 'Taiwan' },

  { value: '+961', label: '+961', name: 'Lebanon' },
  { value: '+962', label: '+962', name: 'Jordan' },
  { value: '+963', label: '+963', name: 'Syria' },
  { value: '+964', label: '+964', name: 'Iraq' },
  { value: '+965', label: '+965', name: 'Kuwait' },
  { value: '+966', label: '+966', name: 'Saudi Arabia' },
  { value: '+967', label: '+967', name: 'Yemen' },
  { value: '+968', label: '+968', name: 'Oman' },
  { value: '+970', label: '+970', name: 'Palestine' },
  { value: '+971', label: '+971', name: 'UAE' },
  { value: '+972', label: '+972', name: 'Israel' },
  { value: '+973', label: '+973', name: 'Bahrain' },
  { value: '+974', label: '+974', name: 'Qatar' },
  { value: '+975', label: '+975', name: 'Bhutan' },
  { value: '+976', label: '+976', name: 'Mongolia' },
  { value: '+977', label: '+977', name: 'Nepal' },
  { value: '+992', label: '+992', name: 'Tajikistan' },
  { value: '+993', label: '+993', name: 'Turkmenistan' },
  { value: '+994', label: '+994', name: 'Azerbaijan' },
  { value: '+995', label: '+995', name: 'Georgia' },
  { value: '+996', label: '+996', name: 'Kyrgyzstan' },
  { value: '+998', label: '+998', name: 'Uzbekistan' },
];
